<template>
  <form :action="route('cart.ticket')" @submit.prevent="submit">

    <div class="mb-8">
      <h3 class="text-lg font-semibold mb-1">Aufführungstermin</h3>
      <p class="text-gray-700">Wählen Sie Ihren Wunschtermin</p>

      <Select
        class="mt-4 w-96 max-w-full"
        v-model="form.event"
        :error="form.errors.event"
      >
        <option
          v-for="event in event.options"
          :value="event.id"
        >
          {{ formatDate(event.date, 'dd. DD.MM.YYYY, HH:mm [Uhr]') }}
          ( {{ event.tickets_available }} / {{ event.tickets_count }} )
        </option>
      </Select>
    </div>

    <div class="mb-12">
      <h3 class="text-lg font-semibold mb-1">Ticketanzahl</h3>
      <p class="text-gray-700">Wie viele Tickets möchten Sie erwerben?</p>

      <Select
        class="mt-4 w-96 max-w-full"
        v-model="form.amount"
        :error="form.errors.amount"
      >
        <option v-for="n in 15" :value="n" :key="n">
          {{ n }}
        </option>
      </Select>
    </div>

    <div class="mb-4">
      <small class="text-sm text-gray-700 tracking-wider">Die Preisberechnung erfolgt im Warenkorb.</small>
    </div>

    <button class="button" type="submit" :disabled="form.processing">
      In den Warenkorb
    </button>

    <div v-if="state.error" class="mt-4 text-red-500 text-sm">
      {{ state.error }}
    </div>
  </form>
</template>

<script>
import Select from 'Web/Form/Fields/SelectField.vue';
import formatDate from '@/helpers/formatDate';
import { useForm } from '@inertiajs/inertia-vue3/dist';
import { reactive, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';

export default {
  inheritAttrs: false,
  components: {
    Select,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      default: null,
    }
  },
  setup(props) {
    const state = reactive({
      error: null,
    });

    const form = useForm({
      event: props.date,
      amount: 1,
    });

    function onSuccess(page) {
      state.error = null;
    }

    function onError(error) {
      state.error = error.exception ?? null;
    }

    function submit(event) {
      form.post(event.target.action, {
        preserveScroll: true,
        preserveState: true,
        onSuccess,
        onError,
      });
    }

    watch(() => form.event, date => {
      Inertia.reload({
        replace: true,
        data: { date },
      });
    });

    return {
      form,
      formatDate,
      state,
      submit,
    }
  }
}
</script>
